// import React, { useEffect, useState } from "react";
// import moment from "moment";
// import { useNavigate } from "react-router-dom";
// import type { IFilter } from "../../components/common/CommonFilter";
// import {
//   Building2,
//   Eye,
//   Pencil,
//   Plus,
//   Trash2,
// } from "lucide-react";
// import { showToastNotification } from "../../utility/helper";
// import MainHeading from "../../components/common/MainHeading";
// import CommonFilter from "../../components/common/CommonFilter";
// import CommonTable, {
//   type TableColumn,
// } from "../../components/common/CommonTable";
// import TablePagination from "../../components/common/TablePagination";
// import { RoutesLink } from "../../utility/RouteLinks";
// import { ThrowError } from "../../api/callApi";
// import { SiteService } from "@/services/Site/Site";
// import type { ISite, SiteStatus } from "@/interface/site.interface";
// import CommonModal from "@/components/common/CommonModal";
// import RowActionsMenu from "@/components/common/RowActionsMenu";

// export interface IPageInfo {
//   currentPage: number;
//   pageSize: number;
//   total: number;
//   totalPages: number;
// }


// const STATUS_OPTIONS = [
//   { label: "All", value: "" },
//   { label: "Active", value: "active" },
//   { label: "Completed", value: "completed" },
//   { label: "On Hold", value: "on-hold" },
// ];

// // Solid pill style — bold, uppercase, dot-prefixed — matching Labor/Shift status badges.
// const STATUS_STYLES: Record<SiteStatus, { bg: string; text: string; dot: string }> = {
//   active: { bg: "bg-green-50", text: "text-green-600", dot: "bg-green-500" },
//   completed: { bg: "bg-blue-50", text: "text-blue-600", dot: "bg-blue-500" },
//   "on-hold": { bg: "bg-amber-50", text: "text-amber-600", dot: "bg-amber-500" },
// };

// const STATUS_LABELS: Record<SiteStatus, string> = {
//   active: "Active",
//   completed: "Completed",
//   "on-hold": "On Hold",
// };



// const Sites: React.FC = () => {
//   const navigate = useNavigate();
//   const [isLoading, setIsLoading] = useState(false);
//   const [siteList, setSiteList] = useState<ISite[]>([]);


//   const [statTotals, setStatTotals] = useState({
//     total: 0,
//     active: 0,
//     completed: 0,
//     totalWorkers: 0,
//   });

//   const [filter, setFilter] = useState<IFilter>({
//     search: "",
//     status: "",
//   });

//   const [paginationData, setPaginationData] = useState<IPageInfo>({
//     currentPage: 1,
//     pageSize: 10,
//     total: 0,
//     totalPages: 0,
//   });

//   const [deleteModalOpen, setDeleteModalOpen] = useState(false);
//   const [siteToDelete, setSiteToDelete] = useState<string | null>(null);


//   const fetchSites = async (
//     page = paginationData.currentPage,
//     limit = paginationData.pageSize,
//   ) => {
//     setIsLoading(true);
//     try {
//       const response = await SiteService.getSiteList({
//         pageIndex: page,
//         pageSize: limit,
//         search: filter.search || undefined, // empty → undefined → not sent
//         status: filter.status || undefined, // empty → undefined → not sent
//         sort: "createdAt",
//         order: "DESC",
//       });

//       if (response?.success) {
//         const { rows, pageIndex, pageSize, total, totalPages, summary } =
//           response.data;

//         setSiteList(rows || []);
//         setPaginationData({
//           currentPage: pageIndex,
//           pageSize,
//           total,
//           totalPages,
//         });

//         if (summary) {
//           setStatTotals({
//             total: summary.totalSites ?? 0,
//             active: summary.activeSites ?? 0,
//             completed: summary.completed ?? 0,
//             totalWorkers: summary.totalWorkers ?? 0,
//           });
//         }
//       }
//     } catch (error) {
//       ThrowError(error);
//     } finally {
//       setIsLoading(false);
//     }
//   };


//   useEffect(() => {
//     fetchSites(paginationData.currentPage, paginationData.pageSize);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [paginationData.currentPage, paginationData.pageSize, filter]);



//   const handleSearchChange = (value: string) => {
//     setFilter((prev) => ({ ...prev, search: value }));
//     setPaginationData((prev) => ({ ...prev, currentPage: 1 }));
//   };

//   const handleFilterChange = (value: string, name: string) => {
//     setFilter((prev) => ({ ...prev, [name]: value }));
//     setPaginationData((prev) => ({ ...prev, currentPage: 1 }));
//   };

//   const handleChangePageSize = (value: number) => {
//     setPaginationData((prev) => ({ ...prev, pageSize: value, currentPage: 1 }));
//   };

//   const handleDelete = async (id: string) => {
//     try {
//       const response = await SiteService.deleteSite(id);
//       if (response?.success) {
//         showToastNotification("success", response.message || "Site deleted");
//         fetchSites(paginationData.currentPage, paginationData.pageSize);
//       } else {
//         showToastNotification(
//           "danger",
//           response?.message || "Failed to delete site",
//         );
//       }
//     } catch (error) {
//       ThrowError(error);
//     }
//   };

//   const openDeleteModal = (id: string) => {
//     setSiteToDelete(id);
//     setDeleteModalOpen(true);
//   };

//   const confirmDelete = () => {
//     if (siteToDelete) {
//       handleDelete(siteToDelete);
//       setDeleteModalOpen(false);
//       setSiteToDelete(null);
//     }
//   };

//   const cancelDelete = () => {
//     setDeleteModalOpen(false);
//     setSiteToDelete(null);
//   };


//   const columns: TableColumn<ISite>[] = [
//     {
//       key: "sNo",
//       header: "S.No",
//       render: (_item, index) => (
//         <span className="text-muted-foreground font-medium text-sm">
//           {(paginationData.currentPage - 1) * paginationData.pageSize +
//             index +
//             1}
//         </span>
//       ),
//     },
//     {
//       key: "siteName",
//       header: "Site",
//       render: (item) => (
//         <div className="flex items-center gap-3">
//           <div className="h-9 w-9 rounded-lg bg-primary/10 flex items-center justify-center text-primary shrink-0">
//             <Building2 size={16} />
//           </div>
//           <div className="min-w-0">
//             <p className="font-semibold text-gray-700 truncate">
//               {item.siteName}
//             </p>
//             <p className="text-xs text-gray-400">{item.siteCode}</p>
//           </div>
//         </div>
//       ),
//     },
//     {
//       key: "location",
//       header: "Location",
//       render: (item) => (
//         <div className="text-gray-600">
//           <p className="text-sm">{item.locationAddress}</p>
//           <p className="text-xs text-gray-400">
//             {item.city}
//             {item.city && item.state ? ", " : ""}
//             {item.state}
//           </p>
//         </div>
//       ),
//     },
//     {
//       key: "startDate",
//       header: "Start Date",
//       render: (item) => (
//         <span>
//           {item.startDate ? moment(item.startDate).format("DD-MM-YYYY") : "N/A"}
//         </span>
//       ),
//     },
//     {
//       key: "expectedEndDate",
//       header: "Expected End Date",
//       render: (item) => (
//         <span>
//           {item.expectedEndDate
//             ? moment(item.expectedEndDate).format("DD-MM-YYYY")
//             : "N/A"}
//         </span>
//       ),
//     },
//     {
//       key: "status",
//       header: "Status",
//       render: (item) => {
//         const s = STATUS_STYLES[item.status];
//         return (
//           <span
//             className={`inline-flex items-center gap-1.5 px-2.5 py-1 text-[11px] font-bold uppercase tracking-wide rounded-full ${s.bg} ${s.text}`}
//           >
//             <span className={`h-1.5 w-1.5 rounded-full ${s.dot}`} />
//             {STATUS_LABELS[item.status]}
//           </span>
//         );
//       },
//     },
//     {
//       key: "actions",
//       header: "Actions",
//       render: (item) => (
//         <RowActionsMenu
//           actions={[
//             {
//               label: "View",
//               icon: <Eye className="h-4 w-4" />,
//               onClick: () => navigate(`${RoutesLink.siteDetail}/${item.id}`),
//             },
//             {
//               label: "Edit",
//               icon: <Pencil className="h-4 w-4" />,
//               onClick: () => navigate(`${RoutesLink.editSite}/${item.id}`),
//             },
//             {
//               label: "Delete",
//               icon: <Trash2 className="h-4 w-4" />,
//               onClick: () => openDeleteModal(item.id),
//               variant: "destructive",
//             },
//           ]}
//         />
//       ),
//     },
//   ];

//   return (
//     <div className="space-y-6">
//       <MainHeading
//         title="Site Management"
//         buttonText="Add Site"
//         buttonIcon={<Plus size={16} />}
//         onClick={() => navigate(RoutesLink.createSite)}
//       />

//       <div className="bg-white border border-slate-200/70 rounded-xl shadow-sm p-4 sm:p-5 space-y-4">
//         <CommonFilter
//           searchValue={filter.search || ""}
//           onSearchChange={handleSearchChange}
//           value={filter}
//           filterOptions={STATUS_OPTIONS}
//           filterName="status"
//           filterPlaceholder="Select Status"
//           onChange={handleFilterChange}
//         />
//         <CommonTable
//           data={siteList}
//           columns={columns}
//           loading={isLoading}
//           stickyColumns={2}
//         />
//         <TablePagination
//           paginationData={paginationData}
//           setPaginationData={setPaginationData}
//           handleChangePageSize={handleChangePageSize}
//           isLoading={isLoading}
//         />
//       </div>

//       <CommonModal
//         title="Delete Site"
//         show={deleteModalOpen}
//         onClose={cancelDelete}
//         className="max-w-sm"
//       >
//         <div className="flex flex-col items-center text-center">
//           <div className="h-12 w-12 rounded-full bg-red-50 text-red-600 flex items-center justify-center mb-4">
//             <Trash2 size={22} />
//           </div>
//           <h3 className="text-lg font-bold text-gray-900 mb-1.5">
//             Are you sure?
//           </h3>
//           <p className="text-sm text-gray-500 leading-relaxed mb-6">
//             This action cannot be undone. The site will be permanently removed.
//           </p>
//           <div className="flex items-center gap-3 w-full">
//             <button
//               onClick={cancelDelete}
//               className="flex-1 rounded-xl h-11 border border-gray-200 hover:bg-gray-50 text-gray-700 font-medium"
//             >
//               Cancel
//             </button>
//             <button
//               onClick={confirmDelete}
//               className="flex-1 rounded-xl h-11 bg-red-600 hover:bg-red-700 text-white font-medium flex items-center justify-center gap-2"
//             >
//               Yes, Delete
//             </button>
//           </div>
//         </div>
//       </CommonModal>
//     </div>
//   );
// };

// export default Sites;


import React, { useEffect, useState } from "react";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import type { IFilter } from "../../components/common/CommonFilter";
import { Building2, Eye, Pencil, Plus, Trash2 } from "lucide-react";
import { showToastNotification } from "../../utility/helper";
import MainHeading from "../../components/common/MainHeading";
import CommonFilter from "../../components/common/CommonFilter";
import CommonTable, {
  type TableColumn,
} from "../../components/common/CommonTable";
import TablePagination from "../../components/common/TablePagination";
import { RoutesLink } from "../../utility/RouteLinks";
import { ThrowError } from "../../api/callApi";
import { SiteService } from "@/services/Site/Site";
import type { ISite, SiteStatus } from "@/interface/site.interface";
import CommonModal from "@/components/common/CommonModal";
import RowActionsMenu from "@/components/common/RowActionsMenu";
import { StatusBadge, IconCell } from "../../components/common/Badge";

export interface IPageInfo {
  currentPage: number;
  pageSize: number;
  total: number;
  totalPages: number;
}

const STATUS_OPTIONS = [
  { label: "All", value: "" },
  { label: "Active", value: "active" },
  { label: "Completed", value: "completed" },
  { label: "On Hold", value: "on-hold" },
];

// Display label per status — StatusBadge (shared component) owns the
// color/pill styling, this file only maps the API's status value to
// the label shown in it.
const STATUS_LABELS: Record<SiteStatus, string> = {
  active: "Active",
  completed: "Completed",
  "on-hold": "On Hold",
};

const Sites: React.FC = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [siteList, setSiteList] = useState<ISite[]>([]);

  const [statTotals, setStatTotals] = useState({
    total: 0,
    active: 0,
    completed: 0,
    totalWorkers: 0,
  });

  const [filter, setFilter] = useState<IFilter>({
    search: "",
    status: "",
  });

  const [paginationData, setPaginationData] = useState<IPageInfo>({
    currentPage: 1,
    pageSize: 10,
    total: 0,
    totalPages: 0,
  });

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [siteToDelete, setSiteToDelete] = useState<string | null>(null);

  const fetchSites = async (
    page = paginationData.currentPage,
    limit = paginationData.pageSize,
  ) => {
    setIsLoading(true);
    try {
      const response = await SiteService.getSiteList({
        pageIndex: page,
        pageSize: limit,
        search: filter.search || undefined,
        status: filter.status || undefined,
        sort: "createdAt",
        order: "DESC",
      });

      if (response?.success) {
        const { rows, pageIndex, pageSize, total, totalPages, summary } =
          response.data;

        setSiteList(rows || []);
        setPaginationData({
          currentPage: pageIndex,
          pageSize,
          total,
          totalPages,
        });

        if (summary) {
          setStatTotals({
            total: summary.totalSites ?? 0,
            active: summary.activeSites ?? 0,
            completed: summary.completed ?? 0,
            totalWorkers: summary.totalWorkers ?? 0,
          });
        }
      }
    } catch (error) {
      ThrowError(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchSites(paginationData.currentPage, paginationData.pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginationData.currentPage, paginationData.pageSize, filter]);

  const handleSearchChange = (value: string) => {
    setFilter((prev) => ({ ...prev, search: value }));
    setPaginationData((prev) => ({ ...prev, currentPage: 1 }));
  };

  const handleFilterChange = (value: string, name: string) => {
    setFilter((prev) => ({ ...prev, [name]: value }));
    setPaginationData((prev) => ({ ...prev, currentPage: 1 }));
  };

  const handleChangePageSize = (value: number) => {
    setPaginationData((prev) => ({ ...prev, pageSize: value, currentPage: 1 }));
  };

  const handleDelete = async (id: string) => {
    try {
      const response = await SiteService.deleteSite(id);
      if (response?.success) {
        showToastNotification("success", response.message || "Site deleted");
        fetchSites(paginationData.currentPage, paginationData.pageSize);
      } else {
        showToastNotification(
          "danger",
          response?.message || "Failed to delete site",
        );
      }
    } catch (error) {
      ThrowError(error);
    }
  };

  const openDeleteModal = (id: string) => {
    setSiteToDelete(id);
    setDeleteModalOpen(true);
  };

  const confirmDelete = () => {
    if (siteToDelete) {
      handleDelete(siteToDelete);
      setDeleteModalOpen(false);
      setSiteToDelete(null);
    }
  };

  const cancelDelete = () => {
    setDeleteModalOpen(false);
    setSiteToDelete(null);
  };

  const columns: TableColumn<ISite>[] = [
    {
      key: "sNo",
      header: "S.No",
      render: (_item, index) => (
        <span className="text-muted-foreground font-medium text-sm">
          {(paginationData.currentPage - 1) * paginationData.pageSize +
            index +
            1}
        </span>
      ),
    },
    {
      key: "siteName",
      header: "Site",
      render: (item) => (
        <IconCell
          icon={<Building2 size={16} />}
          title={item.siteName}
          subtitle={item.siteCode}
          tone="indigo"
        />
      ),
    },
    {
      key: "location",
      header: "Location",
      render: (item) => (
        <div className="text-gray-600">
          <p className="text-sm">{item.locationAddress}</p>
          <p className="text-xs text-gray-400">
            {item.city}
            {item.city && item.state ? ", " : ""}
            {item.state}
          </p>
        </div>
      ),
    },
    {
      key: "startDate",
      header: "Start Date",
      render: (item) => (
        <span>
          {item.startDate ? moment(item.startDate).format("DD-MM-YYYY") : "N/A"}
        </span>
      ),
    },
    {
      key: "expectedEndDate",
      header: "Expected End Date",
      render: (item) => (
        <span>
          {item.expectedEndDate
            ? moment(item.expectedEndDate).format("DD-MM-YYYY")
            : "N/A"}
        </span>
      ),
    },
    {
      key: "status",
      header: "Status",
      render: (item) => <StatusBadge status={STATUS_LABELS[item.status]} />,
    },
    {
      key: "actions",
      header: "Actions",
      render: (item) => (
        <RowActionsMenu
          actions={[
            {
              label: "View",
              icon: <Eye className="h-4 w-4" />,
              onClick: () => navigate(`${RoutesLink.siteDetail}/${item.id}`),
            },
            {
              label: "Edit",
              icon: <Pencil className="h-4 w-4" />,
              onClick: () => navigate(`${RoutesLink.editSite}/${item.id}`),
            },
            {
              label: "Delete",
              icon: <Trash2 className="h-4 w-4" />,
              onClick: () => openDeleteModal(item.id),
              variant: "destructive",
            },
          ]}
        />
      ),
    },
  ];

  return (
    <div className="space-y-6">
      <MainHeading
        title="Site Management"
        buttonText="Add Site"
        buttonIcon={<Plus size={16} />}
        onClick={() => navigate(RoutesLink.createSite)}
      />

      <div className="bg-white border border-slate-200/70 rounded-xl shadow-sm p-4 sm:p-5 space-y-4">
        <CommonFilter
          searchValue={filter.search || ""}
          onSearchChange={handleSearchChange}
          value={filter}
          filterOptions={STATUS_OPTIONS}
          filterName="status"
          filterPlaceholder="Select Status"
          onChange={handleFilterChange}
        />
        <CommonTable
          data={siteList}
          columns={columns}
          loading={isLoading}
          stickyColumns={2}
        />
        <TablePagination
          paginationData={paginationData}
          setPaginationData={setPaginationData}
          handleChangePageSize={handleChangePageSize}
          isLoading={isLoading}
        />
      </div>

      <CommonModal
        title="Delete Site"
        show={deleteModalOpen}
        onClose={cancelDelete}
        className="max-w-sm"
      >
        <div className="flex flex-col items-center text-center">
          <div className="h-12 w-12 rounded-full bg-red-50 text-red-600 flex items-center justify-center mb-4">
            <Trash2 size={22} />
          </div>
          <h3 className="text-lg font-bold text-gray-900 mb-1.5">
            Are you sure?
          </h3>
          <p className="text-sm text-gray-500 leading-relaxed mb-6">
            This action cannot be undone. The site will be permanently removed.
          </p>
          <div className="flex items-center gap-3 w-full">
            <button
              onClick={cancelDelete}
              className="flex-1 rounded-xl h-11 border border-gray-200 hover:bg-gray-50 text-gray-700 font-medium"
            >
              Cancel
            </button>
            <button
              onClick={confirmDelete}
              className="flex-1 rounded-xl h-11 bg-red-600 hover:bg-red-700 text-white font-medium flex items-center justify-center gap-2"
            >
              Yes, Delete
            </button>
          </div>
        </div>
      </CommonModal>
    </div>
  );
};

export default Sites;